import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './_routes';

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
	let user = localStorage.getItem('user');
	
	if (to.matched.some((record) => record.meta.requiresAuth)) {
		if (!user){
			next({ path: '/signin', params: { nextUrl: to.fullPath } })
		} else {
			next();
		}
	} else {
		if (user) {
			next({ path: '/edi-invoices', });
		} else {
			next();
		}
	}
});

router.afterEach((to) => {
	document.title = to.meta.title ? to.meta.title + ' | Invoice Audit' : 'Invoice Audit';
});

export default router;